import React, { useState, useEffect } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import EmailIcon from '@mui/icons-material/Email';
import YTIcon from '@mui/icons-material/YouTube';
import '../assets/styles/Footer.scss'

const FarcasterIcon = () => (
  <svg viewBox="0 0 1000 1000" fill="currentColor" width="1em" height="1em" style={{verticalAlign: 'middle'}}>
    <path d="M257.778 155.556H742.222V844.444H671.111V528.889H670.414C662.554 441.677 589.258 373.333 500 373.333C410.742 373.333 337.446 441.677 329.586 528.889H328.889V844.444H257.778V155.556Z"/>
    <path d="M128.889 253.333L157.778 351.111H182.222V746.667C169.949 746.667 160 756.616 160 768.889V795.556H155.556C143.283 795.556 133.333 805.505 133.333 817.778V844.444H382.222V817.778C382.222 805.505 372.273 795.556 360 795.556H355.556V768.889C355.556 756.616 345.606 746.667 333.333 746.667H306.667V351.111H331.111L360 253.333H128.889Z"/>
    <path d="M640 253.333L668.889 351.111H693.333V746.667C681.06 746.667 671.111 756.616 671.111 768.889V795.556H666.667C654.394 795.556 644.444 805.505 644.444 817.778V844.444H893.333V817.778C893.333 805.505 883.384 795.556 871.111 795.556H866.667V768.889C866.667 756.616 856.717 746.667 844.444 746.667H817.778V351.111H842.222L871.111 253.333H640Z"/>
  </svg>
);

function Footer() {
  const [time, setTime] = useState(new Date());
  const [shutdown, setShutdown] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const handleRestart = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleShutdown = () => {
    setShutdown(true);
  };

  if (shutdown) {
    return (
      <footer className="footer-shutdown">
        <div className="shutdown-screen">
          <p>It is now safe to close this tab.</p>
        </div>
      </footer>
    );
  }

  const timeStr = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <footer>
      {/* Shut Down dialog */}
      <div className="shutdown-dialog">
        <div className="shutdown-icon">
          <svg width="40" height="40" viewBox="0 0 32 32" fill="none">
            <rect x="4" y="2" width="24" height="20" rx="2" fill="#3a3a3e" stroke="#666" strokeWidth="1"/>
            <rect x="7" y="5" width="18" height="13" fill="#1a1a1e"/>
            <rect x="10" y="23" width="12" height="2" fill="#3a3a3e" stroke="#666" strokeWidth="0.5"/>
            <rect x="8" y="25" width="16" height="2" rx="1" fill="#3a3a3e" stroke="#666" strokeWidth="0.5"/>
          </svg>
        </div>
        <p className="shutdown-text">Are you sure you want to shut down?</p>
        <div className="shutdown-buttons">
          <button className="shutdown-btn" onClick={handleRestart}>Restart</button>
          <button className="shutdown-btn shutdown-btn--primary" onClick={handleShutdown}>Shut Down</button>
        </div>
      </div>

      {/* System bar */}
      <div className="system-bar">
        <div className="system-bar-social">
          <a href="https://github.com/Omodaka9375" target="_blank" rel="noreferrer"><GitHubIcon/></a>
          <a href="https://www.linkedin.com/in/bdjalic/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          <a href="https://x.com/LordOfThePies4" target="_blank" rel="noreferrer"><TwitterIcon/></a>
          <a href="https://www.youtube.com/@interlooper" target="_blank" rel="noreferrer"><YTIcon/></a>
          <a href="mailto:branislav.djalic@gmail.com" target="_blank" rel="noreferrer"><EmailIcon/></a>
          <a href="https://farcaster.xyz/bane84" target="_blank" rel="noreferrer"><FarcasterIcon/></a>
        </div>
        <span className="system-bar-clock">{timeStr}</span>
      </div>
    </footer>
  );
}

export default Footer;
